import { axios, Response } from '../index'

const deleteMacroArea = (pointId: string): Response<null> => {
  return axios.delete(`/v1/macro-areas/${pointId}`)
}

export default deleteMacroArea
